import { Component } from 'react';
import { Login } from '..';

export default class NotAuthPage extends Component {
  render() {
    return (
      <Login {...this.props} />
    );
  }
}